import { ICFSForm, TSeverity } from '@/models';

export const OnBlurFormFields = [
  'shortDescription',
  'addressInfo.instructions',
];

export const CFSFormFields = [
  {
    key: 'address',
    title: 'Address information',
    name: 'addressInfo',
    items: [
      {
        name: 'address',
        label: 'Address',
        type: 'address',
        autoFocus: true,
        addressColumnsTemplate: 'minmax(0, 1.85fr) minmax(0, 1fr) auto',
        showTruncatedTooltip: true,
        enableBusinessName: true,
        styles: {
          display: 'flex',
          xs: 12,
        },
      },
      {
        name: 'instructions',
        type: 'text',
        label: 'Instructions',
        styles: {
          xs: 12,
        },
        autoComplete: 'off',
      },
    ],
  },
  {
    key: 'emergency',
    title: 'Emergency detail',
    name: '',
    items: [
      {
        name: 'incidentCodes',
        type: 'autocomplete',
        label: 'Incident Code',
        disableClearable: true,
        multiple: true,
        limitTags: 1,
        items: [],
        sx: {
          '&.autocomplete-closed .MuiInputBase-root': {
            minHeight: 36,
            maxHeight: 36,
            alignItems: 'center',
            overflow: 'hidden',
          },
          '&.autocomplete-closed .MuiInputBase-root .MuiAutocomplete-startAdornment':
            {
              display: 'flex',
              alignItems: 'center',
              alignSelf: 'center',
              marginTop: '0 !important',
              marginBottom: 0,
            },
          '&.autocomplete-closed .MuiInputBase-root .MuiChip-label': {
            lineHeight: '20px',
          },
          '&.autocomplete-closed .MuiInputBase-root .MuiAutocomplete-tag': {
            marginTop: 0,
            marginBottom: 0,
          },
          '&.autocomplete-closed .MuiInputBase-root .MuiChip-root': {
            marginTop: 0,
            marginBottom: 0,
          },
          '&.autocomplete-closed .MuiInputBase-root .MuiAutocomplete-endAdornment':
            {
              top: '50%',
              transform: 'translateY(-50%)',
            },
        },
        styles: {
          xs: 7,
        },
      },
      {
        name: 'severity',
        type: 'select',
        label: 'Severity',
        styles: {
          xs: 5,
        },
      },
      {
        name: 'shortDescription',
        type: 'text',
        label: 'Short description',
        styles: {
          xs: 12,
        },
        autoComplete: 'off',
      },
      {
        name: 'assignedAgencies',
        label: 'Agencies',
        type: 'autocomplete',
        disableClearable: true,
        limitTags: 3,
        multiple: true,
        styles: {
          display: 'flex',
          xs: 12,
        },
      },
    ],
  },
];

export const cfsDefaultValues: ICFSForm = {
  addressInfo: {
    instructions: '',
  },
  assignedAgencies: [],
  shortDescription: '',
  incidentCodes: [],
  severity: TSeverity.MEDIUM,
  reporter: {},
};

export const cfsAblyUpdateFields = [
  'requiredUnits',
  'primaryReporter',
  'addressInfo',
  'names',
  'vehicles',
  'hasUnsetInvolvementName',
  'reporter',
];
